import ProjectManagerDepartment from './ProjectManagerDepartment';

export default ProjectManagerDepartment;
